import Swiper from 'swiper';
import { Navigation, Pagination, Mousewheel } from "swiper/modules";
 
 
 
document.addEventListener("DOMContentLoaded", () => {
  console.log("Hey the SWIPPER CODE IS BEING REACHED!!!")
  const swiperElements = document.getElementsByClassName("swiper");
  if (swiperElements.length > 0) {
    new Swiper(".swiper", {
      modules: [Pagination, Mousewheel],
      speed: 700,
      direction: "horizontal",
      spaceBetween: 30,
      slidesPerView: 2.25,
      slidesPerGroup: 1,
      preventInteractionOnTransition: true,
      grabCursor: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      pagination: {
        clickable: true,
        type: "bullets",
        el: ".swiper-pagination",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        480: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1.2,
        },
        1190: {
          slidesPerView: 2.1,
        },
        1500: {
          slidesPerView: 2.25,
        },
        1600: {
          slidesPerView: 3,
        },
      },
    });
  }
 
  const singleSwiperElements = document.getElementsByClassName("single-swiper");
  if (singleSwiperElements.length > 0) {
    new Swiper(".single-swiper", {
      modules: [Navigation, Pagination, Mousewheel],
      speed: 800,
      direction: "horizontal",
      slidesPerView: 1,
      spaceBetween: 100,
      slidesPerGroup: 1,
      preventInteractionOnTransition: true,
      grabCursor: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        //sensitivity: 0.3, // Less sensitive = less likely to skip multiple slides

      },
      navigation: {
        enabled: true,
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        clickable: true,
        type: "bullets",
        el: ".swiper-pagination",
      },
    });
  }
});

